import { ISelectType } from "@4uhub/lib4uhub";

import { GlobalAxios } from "../axios/axios-config";
import { ITicketChannel } from "../models/ticket-channels";
import { ITicketHistoryTicketLink } from "../models/ticket-history-log";

export const TICKET_HISTORY_LOG_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketHistory/logs";

const GENERIC_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/Generic/list";
const TICKET_ROUTE = process.env.REACT_APP_TICKETS + "/api/v1/Ticket/";
const TICKET_CHANNELS_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/TicketChannels/";

export const getTicketHistoryOccurrenceTypes = () => {
  return GlobalAxios.get<ISelectType[]>(GENERIC_ROUTE, {
    params: {
      Identifier: "TicketOccurrenceType",
    },
  });
};

export const getTicketHistoryTicketById = (id: string) => {
  return GlobalAxios.get<ITicketHistoryTicketLink>(TICKET_ROUTE + id);
};

export const getTicketHistoryTicketChannelById = (id: string) => {
  return GlobalAxios.get<ITicketChannel>(TICKET_CHANNELS_ROUTE + id);
};
